import { render, staticRenderFns } from "./FacebookLogs.vue?vue&type=template&id=737d47ae&"
import script from "./FacebookLogs.vue?vue&type=script&lang=js&"
export * from "./FacebookLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports